import { render, staticRenderFns } from "./shipmentFlowView copy.vue?vue&type=template&id=189633de&scoped=true"
import script from "./shipmentFlowView copy.vue?vue&type=script&lang=js"
export * from "./shipmentFlowView copy.vue?vue&type=script&lang=js"
import style0 from "./shipmentFlowView copy.vue?vue&type=style&index=0&id=189633de&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189633de",
  null
  
)

export default component.exports